<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：分配管理员电表
    -->
    <div class="bg_add">
		<div class="addcode">
			<div class="search_code">
				<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="search">
					<el-form-item label="户号">
						<el-input v-model="select.account" placeholder="请输入户号" style="width:120px;float: left;margin-left: 10px;" :maxlength="12"></el-input>
					</el-form-item>
					<el-form-item label="表号">
						<el-input v-model="select.searchCode" placeholder="请输入表号" style="width:120px;float: left;margin-left: 10px;" :maxlength="12"></el-input>
					</el-form-item>
					<el-form-item label="表类型">
						<el-select v-model="select.typess" placeholder="请选择" style="width: 90px;">
							<el-option v-for="item in typess" :key="item.id" :label="item.label" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="业主姓名">
						<el-input v-model="select.owner_name" placeholder="请输入业主姓名" style="width:120px;float: left;margin-left: 10px;" :maxlength="12"></el-input>
					</el-form-item>
					<el-form-item label="地址">
						<el-input v-model="select.address" placeholder="请输入地址" style="width:120px;float: left;margin-left: 10px;"></el-input>
					</el-form-item>
					<el-form-item label="业主类型">
						<el-select v-model="select.nature" placeholder="请选择" style="width: 100px;">
					    <el-option
							v-for="item in natures"
							:key="item.num"
							:label="item.value"
							:value="item.num">
						</el-option>
					 </el-select>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="select.searchRemark" placeholder="请输入备注" style="width:190px;float: left;margin-left: 10px;"></el-input>
					</el-form-item>
					
					<el-form-item>
						<el-radio class="radio" v-model="select.searchStatus" label="0">全部表</el-radio>
						<el-radio class="radio" v-model="select.searchStatus" label="2">已选表</el-radio>
		  				<el-radio class="radio" v-model="select.searchStatus" label="1">未选表</el-radio>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search" class="spanOfaddCode" style="margin-left: 50px;">查询</el-button>
						<el-button type="primary" @click="resetting">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<ul class="codeData">
				<li v-for="(list,index) in lists" :key="index">
					<!--<strong @click="changeListNum(list,index)"
						:style="{'backgroundImage':'url('+imgurl+')'}"
						>
					</strong>
				-->
					<div class="checkbox" :class="{checkboxtrue:list.status == 1}"
							@click="changebox(list,index)"
							>
					</div>
					<!--<span>{{list.meter_id}}</span>-->
					<span class="sb_msg">户号：{{list.account}}</span>
					<span class="sb_msg">表号：{{list.code}}</span>
					<span class="sb_msg">表类型：{{list.type}}</span>
					<span class="small_msg sb_msg">户主姓名：{{list.owner_name}}</span>
					<span class="add_msg sb_msg">地址：{{list.address}}</span>
					<span class="nature_msg sb_msg">业主类型：{{list.nature}}</span>
					<span class="remark_msg"><h3>备注：</h3><p>{{list.remark}}</p></span>
				</li>
				 <el-pagination
				 	@size-change="handleSizeChange"
		      		@current-change="handleCurrentChange"
				 	:page-size="pageSize"
				    layout="total,prev, pager, next"
				    :total="listLength"
					style="margin: 15px 0 20px 0;"
			      >
			    </el-pagination>
			</ul>
			<div class="custom_allcheck" style="width: 74px;">
				<div class="checkbox" v-model="checkall"
				 	:class="{checkboxtrue:checkall == true}"
							@click="allcheck()"
							>
				</div>
				全选
			</div>
				 
			<el-button type="primary" style="width: 120px;" :disabled="true" v-if="codegirysumbit">提交</el-button>
			 <el-button type="primary" @click="sumbitCode()" style="width: 120px;" v-if="codeSumbit">提交</el-button>
			<el-button @click="pageback" class="spanOfaddCode" style="width: 120px;">取消</el-button>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default{
		name:'add-code',
		data(){
			return{
				select:{
					account: '',
					searchCode:'',
					searchRemark:'',
					searchStatus:'0',
					nature:'',
					owner_name:'',
					address:'',
					typess:'',
				},
				codeSumbit:false,
				codegirysumbit:true,
				checkall:false,
				searchStatus:'0',
				checked:'',
				lists:[],
				codeids:[
					{
						codeid:'',
						codestatus:0,
					}
				],
				typess: [
					{
						id: '7',
						label: '水表'
					},
					{
						id: '10',
						label: '多功能单相'
					},
					{
						id: '11',
						label: '多功能三相'
					}
				],
				natures:[
					/*{
						num:'0',
						value:'居民',
					},
					{
						num:'1',
						value:'自营'
					},
					{
						num:"2",
						value:'联营'
					},
					{
						num:'3',
						value:'出租'
					},
					{
						num:'4',
						value:'物业动力'
					},
					{
						num:'5',
						value:'居民配套'
					},
					{
						num:'9',
						value:'备用'
					},*/
					
					
				],
				listnum:'',
				listLength:0,
				pageSize:12,
			}
		},
		created:function(){
			this.postcodedata()
			this.searchNature()
		},
		methods:{
			searchNature(){
				this.$jssdk.member.getNature({
					
				},(res) =>{
					this.natures = res
					console.log(res)
				})
			},
			allcheck(){
				this.checkall = !this.checkall
				this.codeSumbit = true
				this.codegirysumbit = false
				for(var i=0;i<this.lists.length;i++){
					if(this.checkall == true){
						this.lists[i].status = '1'
					}else{
						this.lists[i].status = '0'
					}
				}
			},
			changebox(list,index){
				this.codeSumbit = true
				this.codegirysumbit = false
				if(list.status == 0){
					 list.status = 1
				}else{
					list.status = 0
				}
				if(list.status != 1){
					this.checkall = false
				}
				this.checkall = true
				for(var i=0;i<this.lists.length;i++){
					if(this.lists[i].status == 0){
						this.checkall = false
					}
				}
			},
			search(){
				const account = this.select.account
				const searchCode = this.select.searchCode
				const searchRemark = this.select.searchRemark
				const searchStatus = this.select.searchStatus
				let owner_name = this.select.owner_name
				let nature = this.select.nature
				var address = this.select.address
				let typess = this.select.typess
				this.$jssdk.admin.getMeterList(
					{admin_id:this.adminId, account: account,code:searchCode,remark:searchRemark,status:searchStatus,nature:nature,owner_name:owner_name,address:address, type:typess},(data) =>{
						console.log(data)
					this.lists = data.list.data
					this.listLength = data.list.total
					this.codeids = this.lists
					this.checkall = true
					for(var i=0;i<data.list.data.length;i++){
						if(data.list.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.list.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.list.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.list.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.list.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.list.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.list.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
				    for(var i=0;i<this.lists.length;i++){
						if(this.lists[i].status === 0){
							this.checkall = false
						}
					}
				}),(err) =>{
					this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				}
			},
			resetting(){
				this.select.account = ''
				this.select.searchCode = ''
				this.select.searchRemark = ''
				this.select.searchStatus = ''
				this.select.owner_name = ''
				this.select.nature = ''
				this.select.address = ''
				this.select.typess = ''
			},
			pageback(){
				this.$emit('changeCodefalse')
			},
			changeListNum(list,index){
				this.listnum = index
			},
			postcodedata(){
				const searchStatus = this.searchStatus
				this.$jssdk.admin.getMeterList(
					{admin_id:this.adminId,status:searchStatus},(data) =>{
					this.lists = data.list.data
					this.listLength = data.list.total
					this.codeids = this.lists
					this.checkall = true
					for(var i=0;i<data.list.data.length;i++){
						if(data.list.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.list.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.list.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.list.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.list.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.list.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.list.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
			     	for(var i=0;i<this.lists.length;i++){
						if(this.lists[i].status == 0){
							this.checkall = false
						}
					}
				})
			},
			sumbitCode(){
				this.$jssdk.admin.editMeterList({admin_id:this.adminId,meter_id:this.codeids},(data) =>{
						 this.$message.success('修改表成功')
						 this.pageback()
						 return
				}),(err) =>{
					 this.$message.warning(err.msg)
					 return
				}
			},
			handleSizeChange(val) {
		    },
		     handleCurrentChange(val) {
				const account = this.select.account
		     	const searchCode = this.select.searchCode
				const searchRemark = this.select.searchRemark
		     	const searchStatus = this.select.searchStatus
		     	let owner_name = this.select.owner_name
				 let nature = this.select.nature
				 let typess = this.select.typess
		     	this.$jssdk.admin.editMeterList({
		     		admin_id:this.adminId,meter_id:this.codeids
		     	},(data)=>{
		     		this.$jssdk.admin.getMeterList(
						{admin_id:this.adminId, account: account,code:searchCode,remark:searchRemark,status:searchStatus,page:val,nature:nature,owner_name:owner_name},(data) =>{
						this.lists = data.list.data
						this.listLength = data.list.total
						this.codeids = this.lists
						this.checkall = true
						for(var i=0;i<data.list.data.length;i++){
						if(data.list.data[i].nature == '0'){
							this.lists[i].nature = '居民'
						}
						if(data.list.data[i].nature == '1'){
							this.lists[i].nature = '自营'
						}
						if(data.list.data[i].nature == '2'){
							this.lists[i].nature = '联营'
						}
						if(data.list.data[i].nature == '3'){
							this.lists[i].nature = '出租'
						}
						if(data.list.data[i].nature == '4'){
							this.lists[i].nature = '物业动力'
						}
						if(data.list.data[i].nature == '5'){
							this.lists[i].nature = '居民配套'
						}
						if(data.list.data[i].nature == '9'){
							this.lists[i].nature = '备用'
						}
					}
				     	for(var i=0;i<this.lists.length;i++){
							if(this.lists[i].status === 0){
								this.checkall = false
							}
						}
				     	console.log(this.checkall)
					})
		     	})	
		    },
		},
		computed:{
			naturesData(){
				return this.natures = this.nature
			},
			...mapState(['adminId','nature'])
		},
	}
</script>

<style scoped>
	.bg_add{
		background-color: rgba(0,0,0,.7);
		width: 100%;
		height: 965px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 6;
	}
	.addcode{
		width: 1400px;
		background-color: white;
		border: 1px solid #ccc;
		margin: 0 auto;
		color: black;
		padding: 15px;
		text-align: center;
		overflow: hidden;
		margin-top: 40px;
		border:2px solid #8fceff;
		border-radius: 10px;
		box-shadow: 5px 10px 10px rgba(51,51,51,.3);
	}
	.search_code{
		overflow: hidden;
		margin-bottom: 15px;
	}
	.codeData{
		list-style:none;
		margin: 0 0 10px 0;
		padding: 0;
		overflow: hidden;
	}
	.codeData li{
		border-bottom:1px solid #ccc;
		text-align: left;
		overflow: hidden;
		padding-top: 10px;
	}
	.codeData li:first-child{
		border-top:1px solid #ccc;
		padding-top: 10px;
	}
	.codeData span{
		float: left;
		margin:0 15px 0 5px !important;
		display: inline-block;
		font-size: 12px;
		
	}
	.addcode strong{
		width: 25px;
		height: 25px;
		display:inline-block;
		margin: 0;
		padding: 0;
		float: left;
		background-repeat: no-repeat;
	}
	
	.small_msg{
		width: 120px;
	}
	.sb_msg{
		height: 18px;
		line-height: 18px;
	}
	.add_msg{
		width: 220px;
	}
	.nature_msg{
		width: 120px;
	}
	.remark_msg{
		height: 30px;
		overflow: hidden;
		width: 650px;
	}
	.remark_msg h3{
		display: inline-block;
		margin: 0;
		padding: 0;
		height: 30px;
		float: left;
		font-weight: 100;
		font-size: 12px;
	}
	.remark_msg p{
		display: inline-block;
		height: 30px;
		margin: 0;
		width: 610px;
	}
	.custom_status{
		float: left;
		margin-left: 20px;
		margin-bottom: 5px;
	}
	.el-checkbox{
		float: left;
	}
	.checkbox{
		background-image: url(../assets/check.png);
		background-repeat: no-repeat;
		background-size: 100%;
		width: 20px;
		height: 20px;
		display: inline-block;
		float: left;
		padding-top: 20px;
	}
	.checkboxtrue{
		background-image:url(../assets/check_true.png) !important;
	}
</style>


// WEBPACK FOOTER //
// addCode.vue?4847a017